var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 14.69a8.457 8.457 0 00-1.822-2.703 8.492 8.492 0 00-2.701-1.822c-.01-.005-.019-.007-.028-.012a5.606 5.606 0 10-8.889-4.545c0 1.87.916 3.528 2.325 4.548l-.028.01A8.418 8.418 0 002.49 11.99 8.495 8.495 0 000 17.815.181.181 0 00.18 18h1.357c.1 0 .179-.08.181-.176a6.743 6.743 0 011.985-4.62A6.736 6.736 0 018.5 11.216c1.813 0 3.515.706 4.797 1.988a6.742 6.742 0 011.985 4.62c.002.1.081.176.18.176h1.357a.181.181 0 00.18-.185 8.43 8.43 0 00-.666-3.126zM8.5 9.496a3.862 3.862 0 01-2.749-1.14 3.865 3.865 0 01-1.14-2.749c0-1.038.405-2.015 1.14-2.75A3.862 3.862 0 018.5 1.718c1.038 0 2.014.405 2.749 1.14a3.865 3.865 0 011.14 2.75 3.865 3.865 0 01-1.14 2.75A3.862 3.862 0 018.5 9.498z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileName);
export default __webpack_public_path__ + "static/media/profile-name.ac94a4e23b72a5667e3cd688ebe7ff6f.svg";
export { ForwardRef as ReactComponent };